import { render, staticRenderFns } from "./SchoolClassInputDemo.vue?vue&type=template&id=9433c862"
import script from "./SchoolClassInputDemo.vue?vue&type=script&lang=js"
export * from "./SchoolClassInputDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports